import React, { useState } from "react";
import CountUp from "react-countup";
import { Navbar, Nav,  Container, Button, Modal, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./HeroSection.css";
import logo from '../assets/Zarinova-logo.png';
import rating1 from '../assets/client-1.jpg';
import rating2 from '../assets/client-2.jpg';
import rating3 from '../assets/client-33.JPG';
import { Link } from 'react-router-dom';
const ratingData = [
  {
    type: 'icon',
    iconClass: 'bi bi-google fs-2',
    title: '4.9 Our Ratings',
    subtitle: '',
  },
  {
    type: 'avatars',
    images: [rating1, rating2, rating3],
    title: '450+ Clients Trust',
    subtitle: '',
  },
  {
    type: 'text',
    title: '98%',
    subtitle: 'Satisfaction',
  },
];

const HeroSection = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <div className="hero-section position-relative text-white">
      {/* Navbar */}
      <Navbar expand="lg" className="navbar-dark bg-transparent py-3 px-4 position-absolute w-100 z-3">
        <Container>
          <Navbar.Brand href="#" className="fw-bold5 text-white">
            <img src={logo} alt="Zarinova Logo" className="navbar-logo" />

          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto align-items-center gap-3">
               <Nav.Link href="/"  rel="noopener noreferrer" className="text-white">HOME</Nav.Link>
<Nav.Link href="/about"  rel="noopener noreferrer" className="text-white">ABOUT US</Nav.Link>

<Nav.Link href="/services"  rel="noopener noreferrer" className="text-white">SERVICES</Nav.Link>



<Nav.Link href="/gallery"  rel="noopener noreferrer" className="text-white">GALLERY</Nav.Link>

<Nav.Link href="/video"  rel="noopener noreferrer" className="text-white">UP COMMING EVENT</Nav.Link>

<Nav.Link href="/contact"  rel="noopener noreferrer" className="text-white">CONTACT</Nav.Link>


              
              <Button onClick={handleShow} className="learn-more-btn rounded-pill px-4 py-2 text-white">
                Book Now
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Hero Content */}
      <div className="overlay"></div>
      <div className="container position-relative z-2 d-flex flex-column justify-content-center min-vh-100 pt-5 pt-md-7">
        {/* Hero Text */}
        <div className="row align-items-center mt-5">
          <div className="col-md-10">
            <h1 className="display-4 fw-bold slide-up slide-up-delay-1 pt-5">
              Meticulous Planning <br /> And Flawless <br />
              <span className="highlight">Execution Events.</span>
            </h1>

           <p className="mt-3 text-white-50 slide-up slide-up-delay-2">
  From corporate conferences to grand weddings, we bring your vision to life with unmatched precision and creativity. 
  Every detail is carefully orchestrated to deliver a seamless and unforgettable experience for you and your guests.
</p>

            <div className="mt-4 d-flex gap-3">
             <Link to="/services">
  <Button className="learn-more-btn rounded-pill px-4 py-2 text-white">
    Our Services <i className="bi bi-arrow-right ms-2"></i>
  </Button>
</Link>
              <Button variant="link" className="text-white text-decoration-none">
                Get Started →
              </Button>
            </div>
          </div>
        </div>

        {/* Ratings Section */}
       <div className="row mt-5 mb-5">
  <div className="col-12">
    <div
      className="rating-box d-flex flex-column flex-md-row justify-content-between text-center text-md-start align-items-center flex-wrap p-4 rounded-4 border border-white border-opacity-25 slide-from-left"
      style={{ backgroundColor: "rgba(255, 255, 255, 0.05)" }}
    >
      {[
        { count: 200, suffix: "+", label: "SOCIAL EVENTS" },
        { count: 150, suffix: "+", label: "CORPORATE EVENTS" },
        { count: 125, suffix: "+", label: "ARTIST GIGS" },
        { count: 500, suffix: "+", label: "ACTIVATIONS" },
      ].map((item, index) => (
        <div key={index} className="col-12 col-sm-6 col-md-3 mb-3 slide-from-left text-center">
          <h2 className="fw-bold text-white mb-1">
            <CountUp start={0} end={item.count} duration={2} suffix={item.suffix} />
          </h2>
          <p className="mb-0 text-white-50">{item.label}</p>
        </div>
      ))}
    </div>
  </div>
</div>


      </div>

      {/* Booking Modal */}
      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Book an Event</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="formName">
              <Form.Label>Name</Form.Label>
              <Form.Control type="text" placeholder="Enter your name" />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control type="email" placeholder="Enter email" />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formDate">
              <Form.Label>Event Date</Form.Label>
              <Form.Control type="date" />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formDetails">
              <Form.Label>Event Details</Form.Label>
              <Form.Control as="textarea" rows={3} />
            </Form.Group>

            <Button variant="primary1"className="learn-more-btn rounded-pill px-4 py-2 text-white" onClick={handleClose}>
              Submit Booking
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default HeroSection;
